/**
 * Product Page - New Template
 * Handles:
 * - Accordion selectors (Notebook Type, Inside Pages)
 * - Smart Bundle Pricing
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // ============================================
  // ACCORDION FUNCTIONALITY
  // ============================================
  
  const accordions = document.querySelectorAll('.product-accordion');
  let openAccordionId = null;
  
  function initAccordions() {
    accordions.forEach(accordion => {
      const trigger = accordion.querySelector('.accordion-trigger');
      const content = accordion.querySelector('.accordion-content');
      const accordionId = accordion.dataset.accordionId;
      
      if (!trigger || !content) return;
      
      // Click trigger to toggle
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        toggleAccordion(accordionId);
      });
      
      // Clicking inside content should NOT close accordion
      content.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    });
    
    // Cover Color clicks close all accordions
    const coverColorContainer = document.querySelector('.cover-color-card');
    if (coverColorContainer) {
      coverColorContainer.addEventListener('click', () => {
        closeAllAccordions();
      });
    }
  }
  
  function toggleAccordion(accordionId) {
    if (openAccordionId === accordionId) {
      // Close this accordion
      closeAccordion(accordionId);
      openAccordionId = null;
    } else {
      // Close any open accordion, then open this one
      if (openAccordionId) {
        closeAccordion(openAccordionId);
      }
      openAccordion(accordionId);
      openAccordionId = accordionId;
    }
  }
  
  function openAccordion(accordionId) {
    const accordion = document.querySelector(`[data-accordion-id="${accordionId}"]`);
    if (!accordion) return;
    
    // Keep natural order - trigger shows selection, list shows all options
    const container = accordion.querySelector('.accordion-content-inner');
    if (container) {
      const cards = Array.from(container.children);
      
      // Restore original order (in case it was changed)
      cards.sort((a, b) => {
        const indexA = parseInt(a.dataset.originalIndex) || 0;
        const indexB = parseInt(b.dataset.originalIndex) || 0;
        return indexA - indexB;
      });
      
      // Re-insert in sorted order
      cards.forEach(card => container.appendChild(card));
    }
    
    const content = accordion.querySelector('.accordion-content');
    if (content) {
      // Force browser to calculate the content height before animating
      // First, temporarily make content visible to measure it
      content.style.maxHeight = 'none';
      content.style.position = 'absolute';
      content.style.visibility = 'hidden';
      content.style.display = 'block';
      
      const height = content.scrollHeight;
      
      // Reset to collapsed state
      content.style.position = '';
      content.style.visibility = '';
      content.style.display = '';
      content.style.maxHeight = '0';
      
      // Force reflow
      content.offsetHeight;
      
      // Now animate open
      accordion.classList.add('is-open');
      accordion.setAttribute('aria-expanded', 'true');
      content.style.visibility = 'visible';
      content.style.maxHeight = height + 'px';
    } else {
      accordion.classList.add('is-open');
      accordion.setAttribute('aria-expanded', 'true');
    }
  }
  
  function closeAccordion(accordionId) {
    const accordion = document.querySelector(`[data-accordion-id="${accordionId}"]`);
    if (!accordion) return;
    
    // Reorder happens on open, not close - avoids height jump during close animation
    
    accordion.classList.remove('is-open');
    accordion.setAttribute('aria-expanded', 'false');
    
    const content = accordion.querySelector('.accordion-content');
    if (content) {
      content.style.maxHeight = '0';
      content.style.visibility = 'hidden';
    }
  }
  
  function closeAllAccordions() {
    accordions.forEach(accordion => {
      const accordionId = accordion.dataset.accordionId;
      closeAccordion(accordionId);
    });
    openAccordionId = null;
  }
  
  // Expose for external use (e.g., when variant is selected)
  window.productAccordions = {
    close: closeAllAccordions,
    toggle: toggleAccordion
  };
  
  // Initialize accordions
  if (accordions.length > 0) {
    initAccordions();
    initInsidePagesSelection();
    initNotebookTypeSelection();
  }
  
  // "?" icon scroll links use PageFly's data-to-section mechanism (no custom JS needed)
  
  // Handle Inside Pages option selection
  function initInsidePagesSelection() {
    const optionCards = document.querySelectorAll('.accordion-content-inner .inside-pages-option-card');
    const accordion = document.querySelector('[data-accordion-id="inside-pages"]');
    
    optionCards.forEach(card => {
      card.addEventListener('click', () => {
        // Find the radio input inside this card
        const radio = card.querySelector('input[type="radio"]');
        if (!radio) return;
        
        // Check the radio
        radio.checked = true;
        
        // Dispatch change event for Vue to pick up
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        
        // Update is-selected classes
        optionCards.forEach(c => c.classList.remove('is-selected'));
        card.classList.add('is-selected');
        
        // Mark as user-selected (for validation)
        if (accordion) {
          accordion.dataset.userSelected = 'true';
        }
        
        // Remove error styling if present
        clearInsidePagesError();
        
        // Update the accordion trigger summary
        updateAccordionSummary('inside-pages', radio.value, card);
        
        // Immediately close the accordion after selection
        closeAccordion('inside-pages');
        openAccordionId = null;
      });
    });
  }
  
  // Clear error styling from Inside Pages accordion
  function clearInsidePagesError() {
    const accordion = document.querySelector('[data-accordion-id="inside-pages"]');
    if (!accordion) return;
    
    // Remove error class from accordion container
    accordion.classList.remove('inside-pages-error');
    
    // Swap error icon back to placeholder if needed
    const iconEl = accordion.querySelector('.option-card-icon img');
    if (iconEl && iconEl.src.includes('placeholder-error')) {
      const placeholderUrl = iconEl.dataset.placeholderIcon;
      if (placeholderUrl) {
        iconEl.style.opacity = '0';
        setTimeout(() => {
          iconEl.src = placeholderUrl;
          iconEl.style.opacity = '1';
        }, 150);
      }
    }
  }
  
  // Show error styling on Inside Pages accordion
  function showInsidePagesError() {
    const accordion = document.querySelector('[data-accordion-id="inside-pages"]');
    if (!accordion) return;
    
    // Remove and re-add class to restart animation
    accordion.classList.remove('inside-pages-error');
    void accordion.offsetWidth; // Force reflow
    accordion.classList.add('inside-pages-error');
    
    // Swap to error icon
    const iconEl = accordion.querySelector('.option-card-icon img');
    if (iconEl && !iconEl.src.includes('placeholder-error')) {
      const errorUrl = iconEl.dataset.errorIcon;
      if (errorUrl) {
        iconEl.style.opacity = '0';
        setTimeout(() => {
          iconEl.src = errorUrl;
          iconEl.style.opacity = '1';
        }, 150);
      }
    }
    
    // Scroll to the accordion
    accordion.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  
  // Check if Inside Pages has been selected by user
  function isInsidePagesSelected() {
    const accordion = document.querySelector('[data-accordion-id="inside-pages"]');
    return accordion?.dataset.userSelected === 'true';
  }
  
  // Update accordion trigger summary text after selection
  function updateAccordionSummary(accordionId, selectedValue, selectedCard) {
    const accordion = document.querySelector(`[data-accordion-id="${accordionId}"]`);
    if (!accordion) return;
    
    const trigger = accordion.querySelector('.accordion-trigger');
    if (!trigger) return;
    
    const titleEl = trigger.querySelector('.option-title');
    const descEl = trigger.querySelector('.option-description');
    const iconEl = trigger.querySelector('.option-card-icon img');
    
    if (titleEl) {
      titleEl.textContent = selectedValue;
    }
    
    // Get description from the selected card
    if (descEl && selectedCard) {
      const cardDesc = selectedCard.querySelector('.option-description');
      if (cardDesc) {
        descEl.textContent = cardDesc.textContent;
      }
    }
    
    // Update icon using data attribute from selected card
    if (iconEl && selectedCard) {
      const iconUrl = selectedCard.dataset.iconUrl;
      if (iconUrl) {
        iconEl.src = iconUrl;
      }
    }
  }
  
  // Handle Notebook Type option selection
  function initNotebookTypeSelection() {
    const optionCards = document.querySelectorAll('.accordion-content-inner .notebook-type-option-card');
    
    optionCards.forEach(card => {
      card.addEventListener('click', () => {
        // Find the radio input inside this card
        const radio = card.querySelector('input[type="radio"]');
        if (!radio) return;
        
        // Check the radio
        radio.checked = true;
        
        // Dispatch change event for Vue to pick up
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        
        // Update is-selected classes
        optionCards.forEach(c => c.classList.remove('is-selected'));
        card.classList.add('is-selected');
        
        // Update the accordion trigger summary
        updateNotebookTypeSummary(radio.value);
        
        // Close the accordion after selection (same as Inside Pages)
        closeAccordion('notebook-type');
        openAccordionId = null;
      });
    });
  }
  
  // Update Notebook Type accordion trigger after selection
  function updateNotebookTypeSummary(selectedValue) {
    const accordion = document.querySelector('[data-accordion-id="notebook-type"]');
    if (!accordion) return;
    
    const trigger = accordion.querySelector('.accordion-trigger');
    if (!trigger) return;
    
    const titleEl = trigger.querySelector('.option-title');
    const descEl = trigger.querySelector('.option-description');
    const iconEl = trigger.querySelector('.option-card-icon img');
    
    if (titleEl) {
      titleEl.textContent = selectedValue;
    }
    
    // Get description from the selected card
    const selectedCard = accordion.querySelector(`.notebook-type-option-card.is-selected`);
    if (descEl && selectedCard) {
      const cardDesc = selectedCard.querySelector('.option-description');
      if (cardDesc) {
        descEl.textContent = cardDesc.textContent;
      }
    }
    
    // Update icon
    const selectedCardIcon = selectedCard ? selectedCard.querySelector('.option-card-icon img') : null;
    if (iconEl && selectedCardIcon) {
      iconEl.src = selectedCardIcon.src;
    }
  }
  
  // ============================================
  // SMART BUNDLE PRICING
  // ============================================
  
  const pricingContainer = document.querySelector('.smart-bundle-pricing');
  if (!pricingContainer) return;


  // Tier structure - discounts read from cart line_level_discount_allocations
  // Initialized with fallback values; updated dynamically from cart data
  const TIERS = [
    { min: 1, max: 2, discount: 0, label: '1-2 notebooks' },
    { min: 3, max: 5, discount: 200, label: '3+ notebooks' },
    { min: 6, max: 9, discount: 300, label: '6+ notebooks' },
    { min: 10, max: 49, discount: 400, label: '10+ notebooks' },
    { min: 50, max: 99999, discount: 500, label: '50+ notebooks' }
  ];

  let State = {
    cartNotebookCount: 0,
    currentVariantPrice: 0, // cents
    selectedQuantity: 1,
    discountPerUnit: 0 // cents - read from cart
  };

  // Get product data
  const productJsonEl = document.querySelector('.product-json');
  let productData = null;
  if (productJsonEl) {
    productData = JSON.parse(productJsonEl.textContent);
  }

  // Initialize - order matters!
  // 1. Set initial variant price (synchronous)
  updateVariantPrice();
  // 2. Show prices immediately with cart count = 0
  updatePricingDisplay();
  // 3. Set up listeners
  initQuantityListener();
  initVariantListener();
  initCartUpdateListener();
  // 4. Fetch cart and update display with actual cart count
  fetchCartAndUpdate();

  // --- Listen for Ajax cart updates ---
  function initCartUpdateListener() {
    // Theme dispatches 'wetheme-cart-update' on documentElement when cart changes
    document.documentElement.addEventListener('wetheme-cart-update', (e) => {
      // The event detail contains the cart data
      if (e.detail && e.detail.cart) {
        processCartData(e.detail.cart);
      } else {
        // Fallback: fetch fresh cart data
        fetchCartAndUpdate();
      }
    });
  }

  // --- Fetch Cart ---
  function fetchCartAndUpdate() {
    // Use /cart?view=compare (same as theme's Vue cart) instead of /cart.js
    fetch('/cart?view=compare')
      .then(res => res.json())
      .then(cart => {
        processCartData(cart);
      })
      .catch(() => {
        updatePricingDisplay();
      });
  }
  
  // Process cart data (used by both fetch and event listener)
  function processCartData(cart) {
    // Count notebooks and read discount from line items
    let count = 0;
    let discountPerUnit = 0;
    
    cart.items.forEach(item => {
      if (item.product_type === 'Notebook') {
        count += item.quantity;
        
        // Read per-unit discount from line_level_discount_allocations
        // The discount is the same per unit regardless of variant
        if (item.line_level_discount_allocations && 
            item.line_level_discount_allocations.length > 0 &&
            discountPerUnit === 0) {
          const totalLineDiscount = item.line_level_discount_allocations[0].amount;
          discountPerUnit = Math.round(totalLineDiscount / item.quantity);
        }
      }
    });
    
    State.cartNotebookCount = count;
    State.discountPerUnit = discountPerUnit;
    
    // Update the current tier's discount with the real value from cart
    if (count > 0 && discountPerUnit > 0) {
      const cartTierIndex = getTierIndex(count);
      if (cartTierIndex >= 0) {
        TIERS[cartTierIndex].discount = discountPerUnit;
      }
    }

    updatePricingDisplay();
  }
  
  // Helper to find tier index for a given count
  function getTierIndex(count) {
    let tierIndex = -1;
    for (let i = 0; i < TIERS.length; i++) {
      if (count >= TIERS[i].min && count <= TIERS[i].max) {
        tierIndex = i;
        break;
      }
    }
    return tierIndex;
  }

  // --- Quantity Selector ---
  function initQuantityListener() {
    function setupQuantityListeners() {
      const qtyInput = document.querySelector('.js-qty__num');
      
      if (!qtyInput) {
        // Retry if Vue hasn't rendered yet
        setTimeout(setupQuantityListeners, 100);
        return;
      }
      
      // Listen for changes (Vue updates this via v-model)
      qtyInput.addEventListener('change', () => {
        State.selectedQuantity = parseInt(qtyInput.value) || 1;
        updatePricingDisplay();
      });
      qtyInput.addEventListener('input', () => {
        State.selectedQuantity = parseInt(qtyInput.value) || 1;
        updatePricingDisplay();
      });
      
      // Listen for button clicks on quantity buttons
      const qtyBtns = document.querySelectorAll('.js-qty__adjust');
      qtyBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          // Small delay for Vue to update the input value
          setTimeout(() => {
            const currentVal = parseInt(qtyInput.value) || 1;
            if (currentVal !== State.selectedQuantity) {
              State.selectedQuantity = currentVal;
              updatePricingDisplay();
            }
          }, 50);
        });
      });
      
      // Also observe the input for external changes (Vue v-model)
      const observer = new MutationObserver(() => {
        const currentVal = parseInt(qtyInput.value) || 1;
        if (currentVal !== State.selectedQuantity) {
          State.selectedQuantity = currentVal;
          updatePricingDisplay();
        }
      });
      observer.observe(qtyInput, { attributes: true, attributeFilter: ['value'] });
    }
    
    setupQuantityListeners();
  }

  // --- Variant Changes ---
  function initVariantListener() {
    // Listen for variant option changes - Vue updates the URL
    const form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('change', () => {
        // Small delay for Vue to update the URL
        setTimeout(() => {
          updateVariantPrice();
          updatePricingDisplay();
        }, 10);
      });
    }
    
    // Also listen for browser back/forward
    window.addEventListener('popstate', () => {
      updateVariantPrice();
      updatePricingDisplay();
    });
  }

  function updateVariantPrice() {
    if (!productData || !productData.variants) return;
    
    let variant = null;
    
    // Get variant ID from URL (Vue updates this on selection change)
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    
    if (variantId) {
      variant = productData.variants.find(v => String(v.id) === variantId);
    }
    
    // Fallback to first available variant
    if (!variant) {
      variant = productData.variants.find(v => v.available) || productData.variants[0];
    }
    
    if (variant) {
      State.currentVariantPrice = variant.price; // cents
      
      // Update header label (e.g., "Compact softcover price")
      const headerLabel = document.getElementById('TierHeaderLabel');
      if (headerLabel && variant.option1) {
        headerLabel.textContent = `${variant.option1} price`;
      }
    }
  }

  // --- Update Pricing Display ---
  function updatePricingDisplay() {
    const totalUnits = State.cartNotebookCount + State.selectedQuantity;
    
    // Find active tier
    let activeTierIndex = 0;
    for (let i = 0; i < TIERS.length; i++) {
      if (totalUnits >= TIERS[i].min) {
        activeTierIndex = i;
      }
    }
    
    // Find highlight tier (based on cart count + quantity selector)
    let highlightTierIndex = -1;
    if (totalUnits > 0) {
      for (let i = 0; i < TIERS.length; i++) {
        if (totalUnits >= TIERS[i].min) {
          highlightTierIndex = i;
        }
      }
    }
    
    // Update tier rows
    const rows = document.querySelectorAll('.tier-row');
    rows.forEach((row, index) => {
      // Calculate tier price
      const tierDiscount = TIERS[index] ? TIERS[index].discount : 0;
      const tierPrice = State.currentVariantPrice - tierDiscount;
      
      // Update price display
      const priceEl = row.querySelector('.tier-price');
      if (priceEl) {
        priceEl.textContent = formatMoney(tierPrice) + ' each';
      }
      
      // Highlight logic:
      // - Yellow highlight: tier that matches cart count + quantity selector
      // - Demoted (grey): tiers below the highlighted tier
      
      row.classList.remove('active-tier', 'inactive-tier', 'highlight-tier');
      
      const isHighlightTier = (index === highlightTierIndex && totalUnits > 0);
      
      if (isHighlightTier) {
        // Highlight the tier matching cart + quantity
        row.classList.add('highlight-tier');
      } else if (highlightTierIndex >= 0 && index < highlightTierIndex) {
        // Demoted tiers (below highlighted tier)
        row.classList.add('inactive-tier');
      }
      
      if (index === activeTierIndex) {
        row.classList.add('active-tier');
      }
    });
    
    // Update "Your Price" display
    const activeTierDiscount = TIERS[activeTierIndex] ? TIERS[activeTierIndex].discount : 0;
    const yourPrice = State.currentVariantPrice - activeTierDiscount;
    
    const yourPriceEl = document.querySelector('.your-price-value');
    if (yourPriceEl) {
      yourPriceEl.textContent = formatMoney(yourPrice);
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ============================================
  // ADD TO CART VALIDATION
  // ============================================
  
  function initAddToCartValidation() {
    // Intercept add to cart button clicks
    document.addEventListener('click', function(e) {
      const addToCartBtn = e.target.closest('[data-action="add-to-cart"], .add-to-cart, button[name="add"], #AddToCart');
      
      if (!addToCartBtn) return;
      
      // Check if Inside Pages has been selected
      if (!isInsidePagesSelected()) {
        e.preventDefault();
        e.stopPropagation();
        
        // Show error styling
        showInsidePagesError();
        
        return false;
      }
    }, true); // Use capture phase to intercept before other handlers
  }
  
  // Initialize validation
  initAddToCartValidation();

});
